<template>
  <v-dialog
    v-model="showDialogConfirmToken"
    max-width="700px"
    persistent
    :retain-focus="false"
    :fullscreen="this.$vuetify.breakpoint.xsOnly"
    style="z-index: 1;"
  >
    <template v-slot:activator="{}">
      <v-btn
        :class="{ 'mt-3 ml-4':
          !$vuetify.breakpoint.smAndDown && type === 'playerPromotions'
        }"
        class="primary text-subtitle-1"
        :block="$vuetify.breakpoint.smAndDown || type === 'dashMyPromotions' ?
          true :
          false
        "
        :loading="loading"
        :disabled="!isValidToken || !promotionTokenExist"
        @click="openDialogConfirmToken()"
      >
        {{ $t("redeem") }}
      </v-btn>
    </template>

    <v-card class="colorDominant" v-if="promotionTokenData">
      <div class="d-flex pa-2">
        <v-spacer></v-spacer>
        <v-btn
          class="black"
          icon
          @click="closeDialogConfirmToken()"
          style="z-index: 1;"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
      
      <div v-if="promotionTokenData.image">
        <v-img
          v-show="promotionTokenData.image"
          class="mt-n13 mb-4"
          cover
          position="top"
          aspect-ratio="1.77"
          :src="promotionTokenData.image"
          @error="imageError({ src: promotionTokenData.image, code: promotionTokenData.codigo })"
        ></v-img>
      </div>

      <div
        v-if="promotionTokenData"
        :class="$vuetify.breakpoint.smAndDown ? 'px-4' : 'px-8 pb-8'"
      >
        <!-- Info promo token -->
        <div>
          <div class="text-h6 font-weight-medium">
            {{ promotionTokenData.titulo }}
          </div>
          <div class="mt-2 text-subtitle-1">
            {{ promotionTokenData.descricao }}
          </div>
        </div>
        <!-- Regras promo token -->
        <div class="my-5">
          <div
            class="scroll v-card v-sheet theme--dark pa-4"
            style="height: 200px;"
            v-html="promotionTokenData.regras"
          ></div>
        </div>
        <!-- Promoção ativa -->
        <div v-if="userHasPromotionActive">
          <v-alert type="warning" border="left">
            {{ $t("currentlyYouGotThisPromotion") }}
            {{ promotionActive.titulo }}
          </v-alert>
          <v-checkbox
            v-model="allowDeactivateCurrentPromo"
            :label="$t('allowDeactivateCurrentPromo')"
          ></v-checkbox>
        </div>
        <!-- Botões de cancelar e resgatar -->
        <div class="d-flex">
          <v-spacer></v-spacer>
          <v-btn
            class="mr-2"
            outlined
            color="primary"
            :disabled="loading"
            @click="closeDialogConfirmToken()"
          >
            {{ $t("BtnCancel") }}
          </v-btn>
          <v-btn
            class="primary"
            :loading="loading"
            :disabled="userHasPromotionActive && !allowDeactivateCurrentPromo"
            @click="redeemToken()"
          >
            {{ $t("redeem") }}</v-btn>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: "dialog-confirm-token",
  props: ["type" ,"token", "isValidToken"],
  data: () => ({
    promotionTokenExist: false,
    promotionTokenId: null,
    promotionTokenData: null,
    possibleExtensions: ["png", "jpg", "jpeg", "webp"],
    userHasPromotionActive: false,
    promotionActive: null,
    allowDeactivateCurrentPromo: false,
    loading: false,
  }),
  mounted() {
    // Verificar se usuário tem alguma promoção ativa
    this.verifyUserPromotionActive();

    if (this.isValidToken) {
      // Verificar se existe a promoção tipo token com o token inserido
      this.verifyPromotionTokenExist();
    } else {
      this.closeDialogConfirmToken();
    }
  },
  watch: {
    token() {
      if (this.isValidToken) this.verifyPromotionTokenExist();
    },
    showDialogConfirmToken() {
      if (this.isValidToken && !this.showDialogConfirmToken)
        this.verifyPromotionTokenExist();
    },
  },
  computed: {
    showDialogConfirmToken() {
      return this.$store.state.showDialogConfirmToken;
    },
  },
  methods: {
    openDialogConfirmToken() {
      this.verifyUserPromotionActive();

      if (this.isValidToken) {
        // Verificar se existe a promoção tipo token com o token inserido
        this.verifyPromotionTokenExist();
      } else {
        this.closeDialogConfirmToken();
      }

      this.$store.commit("showDialogConfirmToken", true);
    },
    closeDialogConfirmToken() {
      this.resetVariables();

      this.$store.commit("showDialogConfirmToken", false);
    },
    resetVariables() {
      this.promotionTokenExist = false;
      this.promotionTokenId = null;
      this.promotionTokenData = null;
      this.userHasPromotionActive = false;
      this.promotionActive = null;
      this.allowDeactivateCurrentPromo = false;
    },
    // Verificar se token existe em alguma promoção (Botão ativador)
    verifyPromotionTokenExist() {
      if (!this.token) {
        return;
      }

      this.loading = true;

      this.$axios
        .post(
          "/player/bonus/promotion/registerPromotionTokenActive",
          this.$formdata({
            code_promo: this.token,
            domain: this.$domain(),
          })
        )
        .then((res) => {
          this.loading = false;
          this.promotionTokenExist = true;
          this.promotionTokenId = res.data.dados;

          this.fetchPromotionToken();
        })
        .catch((err) => {
          this.loading = false;
          this.promotionTokenExist = false;
          this.closeDialogConfirmToken();

          this.$emit("emitMsgTokenAlert", err.response.data.messages.error);
        });
    },
    // Buscar dados das promoção tipo Token ao qual o token inserido faz parte
    fetchPromotionToken() {
      if (!this.promotionTokenId) this.closeDialogConfirmToken();

      const body = {
        domain: this.$domain(),
        promotion_id: this.promotionTokenId,
      };

      this.$axios
        .post("/promotion/listPromotion", this.$formdata(body))
        .then((res) => {
          const promotionTokenData = res.data.dados;

          promotionTokenData.image = promotionTokenData.codigo ?
            encodeURI(
              `https://dozr8la71aog.cloudfront.net/domains/${this.$domain()}/promotions/${
                promotionTokenData.codigo
              }.${this.possibleExtensions[0]}`
            ) :
            false;

          this.promotionTokenData = promotionTokenData;
        })
        .catch((err) => {
          this.$emit("emitMsgTokenAlert", err.response.data.messages.error);
        })
    },
    imageError({ src, code }) {
      let currExtension = src.split(".")[src.split(".").length - 1];
      let currExtensionIndex = this.possibleExtensions.indexOf(currExtension);
      let nextExtensionIndex = currExtensionIndex + 1;

      if (nextExtensionIndex == this.possibleExtensions.length) {
        return;
      }

      let nextExtension = this.possibleExtensions[nextExtensionIndex];

      this.promotionTokenData.image = encodeURI(
        `https://dozr8la71aog.cloudfront.net/domains/${this.$domain()}/promotions/${code}.${nextExtension}`
      );
    },
    // Verificar se o usuário tem alguma promoção ativa
    verifyUserPromotionActive() {
      this.$axios
        .post("/player/bonus/promotion/listActives")
        .then((res) => {
          this.userHasPromotionActive = true;
          this.promotionActive = res.data.dados.active_promotion;
        })
        .catch(() => {});
    },
    // Resgatar token inserido
    redeemToken() {
      this.loading = true;

      this.$axios
        .post(
          "/player/online/register/bindToken",
          this.$formdata({
            token: this.token,
          })
        )
        .then((res) => {
          // Fechando dialog do token na view de Minhas Promoções
          this.$emit("closeDialogToken");

          this.$axios.get("/player/online/bank/balanceOnline")
            .then((_res) => {
              this.$store.commit("setCash", _res.data.dados.balance);
              this.$store.commit("setBonus", {
                value: _res.data.dados.balance_bonus,
                status: _res.data.dados.balance_bonus_status,
              });
              this.$store.commit("setAvailableBalance", _res.data.dados.available_balance);
              this.$store.commit("setRestrictedBalance", _res.data.dados.restricted_balance);
          });

          this.$store.commit("setNotification", {
            msg: res.data.messages,
            color: "green",
          });
        })
        .catch((err) => {
          this.$emit("emitMsgTokenAlert", err.response.data.messages.error);

          this.$store.commit("setNotification", {
            msg: err.response.data.messages.error,
            color: "warning",
          });
        })
        .finally(() => {
          this.loading = false;
          this.closeDialogConfirmToken();
        });
    },
  },
}
</script>
<style scoped>
.scroll {
  overflow-y: auto;
  -ms-overflow-style: none;
  scroll-behavior: smooth;
}
.scroll::-webkit-scrollbar-thumb {
  border: 4px solid #242020;
}
.scroll::-webkit-scrollbar-track {
  display: none;
}
.scroll::-webkit-scrollbar {
  width: 14px;
}
</style>
